import React from "react";
import * as Yup from "yup";
import {Form, Button, Badge} from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
const types = {
    "File (photo)": "success",
    "Rate" : "warning",
    "Comment": "info",
    "Check": "dark",
    "Yes/No": "primary",
    "GPS": "danger",
};

export function Badges(task) {
    return (
        <>
            {task.row.map((input, k) => (
                <Badge key={k} variant={types[input] || "danger"} className="p-2 mx-1">
                    {input || "null"}
                </Badge>
            ))}
        </>
    );
}

export const CampaignSchema = Yup.object().shape({
    //materials : Yup.string().min(3, "Minimum 3 symbols").max(500, "Maximum 500 symbols").required("Field is necesssary"),
    name: Yup.string().min(3, "Minimum 3 symbols").max(500, "Maximum 50 symbols").required("Field is necesssary"),
    description: Yup.string().optional(),
    cost: Yup.number().positive().required("Field is necesssary"),
    mall: Yup.string().test({
        name: "mall",
        message: `Mall cannot be null`,
        test: function(value) {
            return value !== "--null--";
        },
    }),
    client: Yup.string().test({
        name: "client",
        message: "Client cannot be null",
        test: function(value) {
            return value !== "--null--";
        },
    }),
});

export function Icon(props) {
    let { id, event, type } = props;
    return (
        <Button
            title="Delete"
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() =>  { 
                event(id, false, parseInt(type) );  
            }}
        >
            <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
            </span>
        </Button>
    );
}

export function InputInventary(props){
    let { current, uid, update, name } = props
    return (
        <th> 
            <Form.Control 
                value={current} 
                min="1"
                onChange={event => update(uid, event.target.value, name)} 
            />
        </th>
    )
}
